module.exports = __webpack_public_path__ + "img/view-and-pickup3.fa789598.png";